var map = {
	"./bottom.png": "b937",
	"./icon1.png": "7b54",
	"./icon2.png": "d616",
	"./icon3.png": "da841",
	"./icon4.png": "446e",
	"./left.png": "a71e",
	"./lstar.png": "99fb",
	"./one.png": "a996",
	"./right.png": "b13d",
	"./rstar.png": "1ba4",
	"./three.png": "b096",
	"./two.png": "c333"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "daed";